import { useState } from 'react';
import { useI18n } from '../i18n';

/** Languages Translation Centre works with most; anything else can be typed in. */
export const COMMON_LANGUAGES = ['SQ', 'EN', 'SR', 'DE', 'FR', 'IT', 'TR', 'MK', 'BS', 'HR', 'ES', 'RU', 'AR'];
const CODE = /^[A-Z]{2,3}(-[A-Z]{2,4})?$/;

/** Full language name for a code in the user's language, e.g. SR → "Serbian" / "serbisht". */
export function languageName(code: string, uiLang: string): string {
  try {
    return new Intl.DisplayNames([uiLang], { type: 'language' }).of(code.toLowerCase()) ?? code;
  } catch {
    return code;
  }
}

/** Tick the language codes needed; the count is shown. Order follows the order they were ticked. */
export function LanguagePicker({ value, onChange, id }: { value: string[]; onChange: (codes: string[]) => void; id?: string }) {
  const { t, lang } = useI18n();
  const [other, setOther] = useState('');
  const toggle = (code: string) => onChange(value.includes(code) ? value.filter((c) => c !== code) : [...value, code]);
  const extra = value.filter((c) => !COMMON_LANGUAGES.includes(c));
  const otherCode = other.trim().toUpperCase();
  const addOther = () => {
    if (!CODE.test(otherCode)) return;
    if (!value.includes(otherCode)) onChange([...value, otherCode]);
    setOther('');
  };
  return (
    <div className="stack" style={{ gap: 8 }} id={id}>
      <div className="lang-chips" role="group">
        {[...COMMON_LANGUAGES, ...extra].map((code) => (
          <button
            key={code}
            type="button"
            className={`lang-chip${value.includes(code) ? ' on' : ''}`}
            aria-pressed={value.includes(code)}
            title={languageName(code, lang)}
            onClick={() => toggle(code)}
          >
            {code}
          </button>
        ))}
      </div>
      <div className="row" style={{ alignItems: 'center' }}>
        <input
          className="input"
          style={{ width: 130 }}
          value={other}
          maxLength={8}
          placeholder={t('lang.otherPlaceholder')}
          aria-label={t('lang.other')}
          onChange={(e) => setOther(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              addOther();
            }
          }}
        />
        <button type="button" className="btn btn-sm" disabled={!CODE.test(otherCode)} onClick={addOther}>{t('common.add')}</button>
        <span className="small muted">
          {value.length === 0 ? t('lang.noneChosen') : t('lang.count', { n: value.length })}
          {value.length > 0 && `: ${value.map((c) => languageName(c, lang)).join(', ')}`}
        </span>
      </div>
    </div>
  );
}
